<app-toolbar [style.flex]="'0 0 ' + (mode == 'edit' ? 44 : 0) + 'px'"></app-toolbar>

@if (mode == 'view') {
    <mat-icon
        class="edit_btn"
        (mousedown)="toggleEditor(); $event.preventDefault()"
        matTooltip="Edit Description"
    >
        edit
    </mat-icon>
}

<div
    class="contents"
>
    <ng-scrollbar
        class="editor-container"
        [class.hidden]="mode != 'edit'"
        [class.expand]="showPreview == 'off' || !showPreview"
        [class.show-toc]="showToc && showToc != 'off'"
        style="background-color: var(--editor-background-color); cursor: text"
        (click)="editorSvc.clEditor.focus()"
    >
        <div
            class="editor markdown-highlighting"
            style="width: 100%"
            [class.linenumbers]="showLineNumbers"
        >
            <div class="editor-underlay"></div>
            <div class="editor-inner"></div>
            <div class="editor-overlay-1"></div>
            <div class="editor-overlay-2"></div>
        </div>
    </ng-scrollbar>

    <ng-scrollbar
        class="preview-container"
        [class.hidden]="showPreview == 'off' || !showPreview"
        [class.expand]="mode != 'edit'"
        [class.show-toc]="showToc && showToc != 'off'"
        style="background-color: var(--preview-background-color)"
    >
        <div
            class="preview"
            style="width: 100%"
        >
            <div class="preview__inner"></div>
        </div>
    </ng-scrollbar>

    <!-- TODO: -->
    <ng-scrollbar
        class="toc-container"
        [style.width]="(showToc == 'off' || !showToc)  ? '0px' : '240px'"
    >
        <div
            class="toc"
        >
            <div class="toc__inner"></div>
        </div>
    </ng-scrollbar>
</div>

<!-- <app-statusbar [style.flex]="'0 0 ' + (mode != 'viewonly' ? 22 : 0) + 'px'"></app-statusbar> -->
